import type { FunctionComponent } from "react";
import { Outlet } from "react-router-dom";

export const DashboardMain: FunctionComponent = () => {
	return (
		<div className="flex flex-col flex-1">
			<div className="mx-auto w-full max-w-screen-xl">
				<Outlet />
			</div>
		</div>
	);
};
